// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__2zQ7G","success":"AnswerItem_success__26S5T","error":"AnswerItem_error__1KZGp"};